import { tv } from 'tailwind-variants'

import { typography } from '@gto/ui/typography'

export type ToggleButtonSize = 'small' | 'medium' | 'large'

export const toggleStyles = tv({
  slots: {
    group: 'flex items-center gap-0.5 rounded-sm p-0.5',
    button: [
      'relative isolate cursor-pointer rounded-xs inline-flex items-center justify-center whitespace-nowrap transition-all duration-100',
      'hover:bg-states-hover',
      'focus-visible:outline-none',
      'after:pointer-events-none after:absolute after:inset-[2px] after:rounded-[3px] after:border after:border-solid after:border-transparent',
      '[&:focus-visible:not(:active)]:after:border-white',
    ],
    indicator: 'rounded-xs bg-states-selected absolute inset-0 -z-10',
  },
  variants: {
    size: {
      small: {
        button: ['h-5 py-[3px] px-2', typography['button/small']],
      },
      medium: {
        button: ['h-7 py-2 px-3', typography['button/medium']],
      },
      large: {
        button: ['h-[44px] min-w-[60px] py-3 px-4', typography['button/large']],
      },
    },
    orientation: {
      horizontal: { group: 'flex-row bg-components-toggle-group-fill' },
      vertical: { group: 'flex-col border border-divider bg-transparent' },
    },
    disabled: {
      true: { button: 'cursor-not-allowed text-text-disabled pointer-events-none' },
    },
  },
  defaultVariants: {
    size: 'medium',
    orientation: 'horizontal',
  },
})
